import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@app/shared/utils/common';

const inputVariants = cva(
  'font-semibold shadow text-base outline-none text-ellipsis caret-secondary-foreground',
  {
    variants: {
      variant: {
        default: 'bg-secondary text-secondary-foreground',
        lightblue: 'bg-secondary disabled:text-foreground/40',
        white: 'bg-white',
      },
      size: {
        default: 'w-full h-12 px-5 rounded-lg',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export interface InputProps
  extends
    Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <input className={cn(inputVariants({ variant, size, className }))} ref={ref} {...props} />
    );
  }
);
Input.displayName = 'Input';

export { Input };
